import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface PicksUpdatedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddToBetSlip?: () => void;
  onReturnToLobby: () => void;
  potentialWin?: string;
  betAmount?: string;
  frameUrl?: string;
  isUpdate?: boolean;
}

/**
 * Bottom-sheet success drawer — same Dialog shell as QuickPicksModal / confirmation.
 */
const PicksUpdatedModal: React.FC<PicksUpdatedModalProps> = ({
  isOpen,
  onClose,
  onReturnToLobby,
}) => {
  const { t } = useTranslation();

  const handleReturnToLobby = () => {
    onReturnToLobby();
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
    >
      <DialogContent data-test-id="picks-updated-modal" className="items-center">
        <DialogHeader>
          <DialogTitle>{t('modal.picksSubmitted.title')}</DialogTitle>
          <DialogDescription>
            {t('modal.picksSubmitted.message')} {t('modal.picksSubmitted.editMessage')}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            data-test-id="return-to-lobby-btn"
            onClick={handleReturnToLobby}
            variant="primary"
            shape="pill"
            size="lg"
            className="w-full"
            showTrailingIcon={false}
          >
            {t('modal.picksSubmitted.returnToLobby')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PicksUpdatedModal;
